<dialog-header [title]="'Select a color'" (close)="onCancel()"></dialog-header>
<div class="color-select-container">
  <div class="inner-container oph-scroll-bar">
    @for (color of colors; track color) {
      <div class="color-block" [style.background-color]="color" (click)="onColorSelect(color)"></div>
    }
  </div>
</div>
<button class="cancel-btn" (click)="onCancel()">cancel</button>
